import { STATIC_IMAGE_BASE } from '@mc/constants'

// https://app.growthbook.io/features/prcng-1266_v1
export const EXPERIMENT_FLAG = 'prcng-1266_v1'

export type Plan = 'masterclass' | 'pro'

export const PLAN_NAMES: Record<Plan, string> = {
  masterclass: 'MasterClass',
  pro: 'MasterClass Pro',
}

export const PRO_SECTION_ID = 'mc-pro-section'
export const PRO_SECTION_LOCATION = 'MasterClass Pro Section'
export const PRO_MEMBERSHIP_LOCATION = 'MasterClass Pro Membership Section'
export const PRO_SECTION_PERSON_IMAGE = `${STATIC_IMAGE_BASE}/prcng-1266_v1_person.png`
export const PRO_SECTION_HAND_IMAGE = `${STATIC_IMAGE_BASE}/prcng-1266_v1_hand.png`
